import { Component, Input, OnInit, TemplateRef, Output, EventEmitter } from '@angular/core';
import { MappingListModel } from 'projects/hhsg-shared-components/src/lib/material-design/models/mappinglist.model';
import { MappingSortingModel } from '../../../models/mappingsorting.model';
import { MappingTagsModel } from 'projects/hhsg-shared-components/src/lib/material-design/models/mappingtags.model';
import { MappingEntityInterface } from '../mapping-entity.interface';

@Component({
  selector: 'hhsg-mapping-container',
  templateUrl: './mapping-container.component.html',
  styleUrls: ['./mapping-container.component.scss']
})
export class MappingContainerComponent {
  @Input() sortOptions: string[];
  @Input() mappingDetailTemplate: TemplateRef<HTMLElement>;
  @Input() legendTemplate: TemplateRef<HTMLElement>;
  @Input() mappings: MappingEntityInterface[];
  @Input() hasLegends: boolean;
  @Input() selection: any;
  @Output() sortTypeChangeEvent = new EventEmitter<any>();
  @Output() setSelectedFilterEvent = new EventEmitter<any>();

  @Output() selectedFilterEvent = new EventEmitter<any>();
  @Output() onSelectionEvent = new EventEmitter<any>();
  @Output() sortUpDownChangeEvent = new EventEmitter<any>();
  @Output() searchChangeEvent = new EventEmitter<any>();

  
  onSortTypesDropDownChanged(event: any) {
    this.sortTypeChangeEvent.emit(event);
  }

  setSelectedFilter(event: any) {
    this.setSelectedFilterEvent.emit(event);
  }


  selectedFilter(event: any) {
    this.selectedFilterEvent.emit(event);
  }

  sortUpDownChange(){
    this.sortUpDownChangeEvent.emit();
  }


  
  constructor() { }

  onSelection(mapping:any){
    this.onSelectionEvent.emit(mapping);
  }
  onSearchChangeEvent(event: any){
    this.searchChangeEvent.emit(event);
  }

}
